import Vue from 'vue';
import config from '@/config';
import { Notification as notify } from 'element-ui';
import axios from 'axios';
import { i18n } from "@/plugins/vue-i18n";
import { apolloClient } from '@/plugins/vue-apollo';
import {
  GET_MATERIALS_REQUESTS,
  GET_MATERIALS_REQUESTS_BY_ID,
  GET_WORKFLOW_STEPS,
  GET_ITEM_NAME_CODE_DROPDOWN,
  GET_PRODUCT_SERVICE_CATEGORY_DROPDOWN,
  GET_UOM,
  GET_MANUFACTURER_DROPDOWN,
  GET_CATEGORY,
  GET_CATEGORY_DEFAULT,
  GET_STOCK_TYPE,
  GET_AVAILABILITY,
  GET_CRITICALLITY_SOS,
  GET_ANUAL_CONSUMPTION,
  GET_EXPENSE_ITEM,
  GET_HAZARD_INDEX,
  GET_RESPONSIBLE_AREA,
  GET_WAREHOUSE,
  GET_STOCK_QUALIFIERS,
  GET_OPERATIONAL_AREA,
  GROUP_TYPE,
  GET_GROUP_REFERENCE,
  GET_EQUIPMENT_REFERENCE,
  GET_COMPONENT_CODE,
  GET_SEGMENT_FAMILY_CLASS,
  GET_SIMILAR_MATERIALS,
  GET_MDM_WORKFLOW_USER,
  GET_MDM_WORKFLOW_STEP_ATTRIBUTE,
  GET_ANALYSTS_NAMES,
  GET_PURCHASING_OFFICERS,
  GET_PRODUCT_SERVICE_CATEGORY_BY_ID,
  GET_WORKFLOW_ID,
  GET_WORKFLOW_ACTIONS,
} from '@/store/graphql/queries/catalogerUser';

import {
  SAVE_MATERIAL_REQUEST,
  UPDATE_MATERIAL_REQUEST,
  INSERT_WORKFLOW_STEP_LOG,
  UPDATE_WORKFLOW_STEP_LOG,
  SEND_EMAIL_NOTIFICATION,
  SET_SUGGESTED_PROVIDERS,
} from '@/store/graphql/mutations/catalogerUser';

const materials = {
  namespaced: true,
  state: {
    materialsRequests: [],
    itemNameCodeDropdown: [],
    productServiceCategoryDropdown: [],
    uomDropdown: [],
    inventoryCategories: [],
    stockType: [],
    availabilityDropdown: [],
    criticallitySosDropdown: [],
    anualConsumptionDropdown: [],
    expenseItemDropdown: [],
    hazardIndexDropdown: [],
    responsibleAreaDropdown: [],
    warehouseDropdown: [],
    stockQualifiersDropdown: [],
    operationalAreaDropdown: [],
    isInstantiated: false,
    groupReference: [],
    equipmentReference: [],
    componentCodeDropdown: [],
    materialRequestVariables: {},
    editMaterialRequestID: null,
    filesForMatReq: [],
    removeUploadedFile: [],
    workflowStep: null,
    workflowStepLogMessage: null,
    logsMaterialRequest: null,
    arrayWorkFlowSteps: null,
    arrayKeyWordsSearch: null,
    tmpDescription: null,
    editMaterialWorkflowStepId: null,
    workflowStepAttribute: null,
    organizationDivisions: {
      array: [],
      ids: [],
      object: {},
    },
    workFlowsUser: [],
    organizationIdCreateMaterial: null,
    fileManagerURL: `${config.ENDPOINTS.NEST_BACKEND}/file-manager`,
    totalProductServiceCategory: 0,
    cloneProductServiceCategory: [],
    groupTypeList: [],
    creationWorkflowID: null,
    workflowActions: [],
  },
  actions: {
    async getMaterialsRequests({ commit }, variables) {
      try {
        const searchQuery = {
          query: GET_MATERIALS_REQUESTS,
          variables,
          fetchPolicy: 'no-cache',
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_MATERIALS_REQUEST', result.data);
          return result.data.listOfRequest;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    getMaterialRequestById(state, id) {
      try {
        const searchQuery = {
          query: GET_MATERIALS_REQUESTS_BY_ID,
          variables: { id },
          fetchPolicy: 'no-cache',
        };
        return apolloClient.query(searchQuery);
      } catch (error) {
        window.console.error(error);
        return null;
      }
    },
    async getWorkFlowSteps({ commit, state }) {
      try {
        const searchQuery = {
          query: GET_WORKFLOW_STEPS,
          variables: {
            workflowId: state.creationWorkflowID,
          },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_WORKFLOW_STEPS_ARRAY', result.data.workflow_steps);
          return result.data.workflow_steps;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getItemNameCodeDropdown({ commit }) {
      try {
        const searchQuery = {
          query: GET_ITEM_NAME_CODE_DROPDOWN,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_ITEM_NAME_CODE_DROPDOWN', result.data.item_name_code_list);
          return result.data.item_name_code_list;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getProductCategory({ commit, state }, variables) {
      try {
        const searchQuery = {
          query: GET_PRODUCT_SERVICE_CATEGORY_DROPDOWN,
          variables,
        };
        if (variables && Object.prototype.hasOwnProperty.call(variables, 'keyWords')) {
          const result = await apolloClient.query(searchQuery);
          if (result && result.data) {
            state.productServiceCategoryDropdown = result.data.list_product_category;
            return result.data.list_product_category;
          }
        } else {
          const result = await apolloClient.query(searchQuery);
          if (result && result.data) {
            commit('SET_PRODUCT_SERVICE_CATEGORY_DROPDOWN', result.data.list_product_category);
            state.totalProductServiceCategory = result.data.count.aggregate.count;
            return result.data.list_product_category;
          }
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getCategoryProductByID(state, variables) {
      try {
        const searchQuery = {
          query: GET_PRODUCT_SERVICE_CATEGORY_BY_ID,
          variables,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          return result.data.getByID;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getUOM({ commit }) {
      try {
        const searchQuery = {
          query: GET_UOM,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_UOM', result.data.uom);
          return result.data.uom;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getManufacturersList(commits, variables) {
      try {
        const searchQuery = {
          query: GET_MANUFACTURER_DROPDOWN,
          variables,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          return result.data.manufacturer_list;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getSegmentFamilyClass(commits, variables) {
      try {
        const searchQuery = {
          query: GET_SEGMENT_FAMILY_CLASS,
          variables,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          return result.data.segmentFamilyClassList;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    getAllDropdownsData_GeneralInformation({ dispatch }) {
      dispatch('getItemNameCodeDropdown');
      dispatch('getProductCategory');
      dispatch('getUOM');
    },
    async getCategoryList({ commit }) {
      try {
        const searchQuery = {
          query: GET_CATEGORY,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_CATEGORY', result.data.category);
          return result.data.category;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getCategoryByDefault() {
      try {
        const searchQuery = {
          query: GET_CATEGORY_DEFAULT,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          return result.data.category[0].id;
        }
      } catch (error) {
        window.console.error(error);
      }
      return null;
    },
    async getStockTypeDropdown({ commit }) {
      try {
        const searchQuery = {
          query: GET_STOCK_TYPE,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_STOCK_TYPE', result.data.stock_type);
          return result.data.stock_type;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getAvailability({ commit }) {
      try {
        const searchQuery = {
          query: GET_AVAILABILITY,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_AVAILABILITY', result.data.availability);
          return result.data.availability;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getCristicallitySos({ commit }) {
      try {
        const searchQuery = {
          query: GET_CRITICALLITY_SOS,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_CRITICALLITY_SOS', result.data.criticallity_sos);
          return result.data.criticallity_sos;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getAnualConsumption({ commit }) {
      try {
        const searchQuery = {
          query: GET_ANUAL_CONSUMPTION,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_ANUAL_CONSUMPTION', result.data.anual_consumption);
          return result.data.anual_consumption;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getExpenseItem({ commit }) {
      try {
        const searchQuery = {
          query: GET_EXPENSE_ITEM,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_EXPENSE_ITEM', result.data.expense_item);
          return result.data.expense_item;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getHazardIndex({ commit }) {
      try {
        const searchQuery = {
          query: GET_HAZARD_INDEX,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_HAZARD_INDEX', result.data.hazard_index);
          return result.data.hazard_index;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getResponsibleArea({ commit }) {
      try {
        const searchQuery = {
          query: GET_RESPONSIBLE_AREA,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_RESPONSIBLE_AREA', result.data.responsible_area);
          return result.data.responsible_area;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getWarehouse({ commit }) {
      try {
        const searchQuery = {
          query: GET_WAREHOUSE,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_WAREHOUSE', result.data.warehouse);
          return result.data.warehouse;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getStockQualifier({ commit }) {
      try {
        const searchQuery = {
          query: GET_STOCK_QUALIFIERS,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_STOCK_QUALIFIERS', result.data.stockQualifiers);
          return result.data.stockQualifiers;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    getAllDropdownsData_Inventory({ dispatch }) {
      dispatch('getCategoryList');
      dispatch('getStockTypeDropdown');
      dispatch('getAvailability');
      dispatch('getCristicallitySos');
      dispatch('getAnualConsumption');
      dispatch('getExpenseItem');
      dispatch('getHazardIndex');
      dispatch('getResponsibleArea');
      dispatch('getWarehouse');
      dispatch('getStockQualifier');
    },
    async getOperationalArea({ commit }) {
      try {
        const searchQuery = {
          query: GET_OPERATIONAL_AREA,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_OPERATIONAL_AREA', result.data.operational_area);
          return result.data.operational_area;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getGroupType({ state }) {
      try {
        const searchQuery = {
          query: GROUP_TYPE,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          state.groupTypeList = result.data.group_type;
          return result.data.group_type;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getGroupReference({ commit }) {
      try {
        const searchQuery = {
          query: GET_GROUP_REFERENCE,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_GROUP_REFERENCE', result.data.group_reference);
          return result.data.group_reference;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getEquipmentReference({ commit }) {
      try {
        const searchQuery = {
          query: GET_EQUIPMENT_REFERENCE,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_EQUIPMENT_REFERENCE', result.data.equipment_reference);
          return result.data.equipment_reference;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getComponentCode({ commit }) {
      try {
        const searchQuery = {
          query: GET_COMPONENT_CODE,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_COMPONENT_CODE', result.data.component_code);
          return result.data.component_code;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    getAllDropdownsData_EquipmentAPL({ state, dispatch }) {
      if (state.isInstantiated) {
        return Promise.resolve([]);
      }
      state.isInstantiated = true; // Call this method just once
      return Promise.all([
        dispatch('getOperationalArea'),
        dispatch('getGroupReference'),
        dispatch('getEquipmentReference'),
        dispatch('getComponentCode'),
        dispatch('getGroupType'),
      ]);
    },
    async saveMaterialRequest({ state, commit, dispatch }, variables) {
        let result = null;
        commit('MAP_DATA_FROM_FRONT_TO_BACK', variables);
        const variablesMapped = state.materialRequestVariables;
        if (variables.actionWorkflowStep && typeof variables.actionWorkflowStep === 'string') {
          switch (variables.actionWorkflowStep) {
            case 'send':
            await dispatch('sendMaterialRequest', variablesMapped);
            break;
            case "approve":
              // const workflow_action = 1;
              await dispatch('approveMaterialRequest', variablesMapped);
              break;
            case "reject":
              await dispatch('rejectMaterialRequest', variablesMapped);
              // const workflow_action = 2;
              break;
            case "cancel":
              // const workflow_action = 3;
              await dispatch('cancelMaterialRequest', variablesMapped);
              break;
            default:
              break;
          }
        } else if (variablesMapped.id) {
          if ((variablesMapped.workflowStepId === state.arrayWorkFlowSteps[2].id || variablesMapped.workflowStepId === state.arrayWorkFlowSteps[3].id) && variablesMapped.shortDescription !== state.tmpDescription) {
            dispatch('saveSearchProvidersAndEditMaterialRequest', variablesMapped);
          }
          await dispatch('updateMaterialRequest', variablesMapped);
        } else {
          result = await dispatch('createMaterialRequest', variablesMapped);
        }
        commit('CLEAR_MATERIAL_REQUEST_VARIABLES');
        return result;
    },
    workflowStepLogCreate(state, variables) {
      try {
        const insertMutation = {
          mutation: INSERT_WORKFLOW_STEP_LOG,
          variables,
        };
        apolloClient.mutate(insertMutation);
      } catch (error) {
        window.console.error("Error on create log: ", error);
      }
    },
    workflowStepLogUpdate(state, variables) {
      try {
        const insertMutation = {
          mutation: UPDATE_WORKFLOW_STEP_LOG,
          variables,
        };
        apolloClient.mutate(insertMutation);
      } catch (error) {
        window.console.error("Error on update log: ", error);
      }
    },
    sendEmailNotification(state, variables) {
      try {
        const insertMutation = {
          mutation: SEND_EMAIL_NOTIFICATION,
          variables,
        };
        apolloClient.mutate(insertMutation);
      } catch (error) {
        window.console.error("Error while sending email: ", error);
      }
    },
    async sendMaterialRequest({ state, dispatch }, variablesMapped) {
      try {
        // Update material request
        const variablesForUpdate = { ...variablesMapped };
        variablesForUpdate.workflowStepId = state.workflowStep.stepApproval;
        variablesForUpdate.lastAction = state.workflowActions[0].id;
        await dispatch('updateMaterialRequest', variablesForUpdate);
        let comment = null;
        if (state.workflowStepLogMessage && state.workflowStepLogMessage.replace(/\s+/g, '').length > 0) {
          comment = state.workflowStepLogMessage;
        }
        if (state.logsMaterialRequest && state.logsMaterialRequest.length > 1) {
          const lastLogOfWorkFlowStep = state.logsMaterialRequest[state.logsMaterialRequest.length - 1];
          const variables = {
            actionId: state.workflowActions[0].id, // workflow_action -> Creado
            actualStep: state.workflowStep.stepApproval,
            beforeStep: variablesMapped.workflowStepId,
            comment,
            materialCreationId: variablesMapped.id,
            workflowId: variablesMapped.workflowId,
            endAction: new Date().toISOString(),
            actionDate: lastLogOfWorkFlowStep.endAction,
          };
          dispatch("workflowStepLogCreate", variables);
        } else {
          const variables = {
            id: state.logsMaterialRequest[0].id,
            comment,
            endAction: new Date().toISOString(),
          };
          dispatch("workflowStepLogUpdate", variables);
        }
        // Send email notification
        const variablesForEmail = {
          materialCreationId: variablesMapped.id,
          workflowStepId: state.workflowStep.stepApproval,
          actionId: state.workflowActions[0].id, // workflow_action -> Creado
          organizationDivisionId: variablesMapped.organizationDivisionId,
        };
        dispatch("sendEmailNotification", variablesForEmail);
      } catch (error) {
        notify.error({
          title: i18n.t("cataloger.pages.createNewMaterial.errorTittle"),
          message: i18n.t("cataloger.pages.createNewMaterial.sendError"),
        });
        window.console.error("Error on send material request", error);
      }
    },
    async approveMaterialRequest({ state, dispatch }, variablesMapped) {
      try {
        // Update material request
        const variablesForUpdate = { ...variablesMapped };
        variablesForUpdate.workflowStepId = state.workflowStep.stepApproval;
        variablesForUpdate.lastAction = state.workflowActions[1].id;
        // variablesForUpdate.isIntegrated = 1; //cuando se esté en la etapa de integración
        if (state.arrayWorkFlowSteps && state.arrayWorkFlowSteps.length > 0) {
          // If step approval is the last step then material request is completed
          if (state.arrayWorkFlowSteps[4].id === state.workflowStep.stepApproval) {
            variablesForUpdate.lastAction = state.workflowActions[4].id;
            variablesForUpdate.isIntegrated = 1;
          }
        }
        await dispatch('updateMaterialRequest', variablesForUpdate);
        // Create new log for material request
        let comment = null;
        if (state.workflowStepLogMessage && state.workflowStepLogMessage.replace(/\s+/g, '').length > 0) {
          comment = state.workflowStepLogMessage;
        }
        const lastLogOfWorkFlowStep = state.logsMaterialRequest[state.logsMaterialRequest.length - 1];
        const variables = {
          actionId: state.workflowActions[1].id, // workflow_action -> Approval
          actualStep: state.workflowStep.stepApproval,
          beforeStep: variablesMapped.workflowStepId,
          comment,
          materialCreationId: variablesMapped.id,
          workflowId: variablesMapped.workflowId,
          endAction: new Date().toISOString(),
          actionDate: lastLogOfWorkFlowStep.endAction,
        };
        dispatch("workflowStepLogCreate", variables);
        // Send email notification
        const variablesForEmail = {
          materialCreationId: variablesMapped.id,
          workflowStepId: state.workflowStep.stepApproval,
          actionId: variablesForUpdate.lastAction,
          organizationDivisionId: variablesMapped.organizationDivisionId,
        };
        dispatch("sendEmailNotification", variablesForEmail);
        // Search providers for material request
        if (state.workflowStep.stepApproval === state.arrayWorkFlowSteps[2].id) {
          dispatch('saveSearchProvidersAndEditMaterialRequest', variablesMapped);
        }
        if (!(state.arrayWorkFlowSteps && state.arrayWorkFlowSteps.length > 0 && state.arrayWorkFlowSteps[4].id === state.workflowStep.stepApproval)) return;
        const variablesIntegrationLog = {
          actionId: state.workflowActions[4].id, // workflow_action -> Integración
          actualStep: state.workflowStep.stepApproval,
          beforeStep: variablesMapped.workflowStepId,
          comment: 'Material disponible para integración',
          materialCreationId: variablesMapped.id,
          workflowId: variablesMapped.workflowId,
          endAction: new Date().toISOString(),
          actionDate: lastLogOfWorkFlowStep.endAction,
        };
        dispatch("workflowStepLogCreate", variablesIntegrationLog);
      } catch (error) {
        notify.error({
          title: i18n.t("cataloger.pages.createNewMaterial.errorTittle"),
          message: i18n.t("cataloger.pages.createNewMaterial.approveError"),
        });
        window.console.error("Error on create material request", error);
      }
    },
    async rejectMaterialRequest({ state, dispatch }, variablesMapped) {
      try {
        // Update material request
        const variablesForUpdate = { ...variablesMapped };
        variablesForUpdate.workflowStepId = state.workflowStep.stepReject;
        variablesForUpdate.lastAction = state.workflowActions[2].id; // workflow_action -> Rechazado
        await dispatch('updateMaterialRequest', variablesForUpdate);
        // Create new log for material request
        let comment = null;
        if (state.workflowStepLogMessage && state.workflowStepLogMessage.replace(/\s+/g, '').length > 0) {
          comment = state.workflowStepLogMessage;
        }
        const lastLogOfWorkFlowStep = state.logsMaterialRequest[state.logsMaterialRequest.length - 1];
        const variables = {
          actionId: state.workflowActions[2].id, // workflow_action -> Rejection
          actualStep: state.workflowStep.stepReject,
          beforeStep: variablesMapped.workflowStepId,
          comment,
          materialCreationId: variablesMapped.id,
          workflowId: variablesMapped.workflowId,
          endAction: new Date().toISOString(),
          actionDate: lastLogOfWorkFlowStep.endAction,
        };
        dispatch("workflowStepLogCreate", variables);
        // Send email notification
        const variablesForEmail = {
          materialCreationId: variablesMapped.id,
          workflowStepId: state.workflowStep.stepReject,
          actionId: state.workflowActions[2].id, // workflow_action -> Rejection
          organizationDivisionId: variablesMapped.organizationDivisionId,
        };
        dispatch("sendEmailNotification", variablesForEmail);
      } catch (error) {
        notify.error({
          title: i18n.t("cataloger.pages.createNewMaterial.errorTittle"),
          message: i18n.t("cataloger.pages.createNewMaterial.rejectError"),
        });
        window.console.error("Error on create material request", error);
      }
    },
    async createMaterialRequest({ dispatch, state }, variables) {
      try {
        let searchStatistics = null;
        if (state.arrayKeyWordsSearch && state.arrayKeyWordsSearch.length > 0) {
          const arrJoined = state.arrayKeyWordsSearch.join(", ").toString();
          if (arrJoined) {
            searchStatistics = arrJoined;
          }
        }
        const insertMutation = {
          mutation: SAVE_MATERIAL_REQUEST,
          variables: { ...variables, searchStatistics },
        };
        const result = await apolloClient.mutate(insertMutation);
        if (result && result.data && result.data.insert_mdm_collahuasi_material_creation && result.data.insert_mdm_collahuasi_material_creation.returning.length > 0) {
          // Material is created
          const materialId = result.data.insert_mdm_collahuasi_material_creation.returning[0].id;
          const variablesForLog = {
            actionId: state.workflowActions[0].id, // workflow_action -> Creation
            actualStep: variables.workflowStepId,
            beforeStep: variables.workflowStepId,
            comment: null,
            materialCreationId: materialId,
            workflowId: variables.workflowId,
            actionDate: new Date().toISOString(),
          };
          dispatch("workflowStepLogCreate", variablesForLog);
          if (state.filesForMatReq && state.filesForMatReq.length > 0) {
            // Material request have attached documents
            const files = state.filesForMatReq;
            await dispatch('uploadAttachments', { materialId, files });
          }
          notify({
            type: "success",
            title: i18n.t("cataloger.pages.createNewMaterial.tittleCreationSuccess"),
            message: i18n.t("cataloger.pages.createNewMaterial.creationSuccess"),
          });
          return materialId;
        }
        throw new Error("Create material request failed");
      } catch (error) {
        notify.error({
          title: i18n.t("cataloger.pages.createNewMaterial.tittleCreationError"),
          message: i18n.t("cataloger.pages.createNewMaterial.creationError"),
        });
        window.console.error("Error on create material request", error);
        return null;
      }
    },
    async updateMaterialRequest({ dispatch, state }, variables) {
      try {
        // Update material request
        const insertMutation = {
          mutation: UPDATE_MATERIAL_REQUEST,
          variables,
        };
        const result = await apolloClient.mutate(insertMutation);
        if (!result || result.errors) {
          throw new Error("Update material request failed");
        }
        notify({
          type: "success",
          title: i18n.t("cataloger.pages.createNewMaterial.tittleCreationSuccess"),
          message: i18n.t("cataloger.pages.createNewMaterial.editionSuccess"),
        });
        // Check if Material request have attached documents
        if (state.filesForMatReq && state.filesForMatReq.length > 0) {
          // Filter new attached files from the existing ones in order to upload them.
          const newFiles = state.filesForMatReq.filter(file => !file.nameForHasura);
          if (newFiles.length > 0) {
            // Material request have new attached files to upload
            await dispatch('uploadAttachments', { materialId: variables.id, files: newFiles });
          }
        }
        // Check if Material request have uploaded files to delete
        if (state.removeUploadedFile && state.removeUploadedFile.length > 0) {
          const namesOfFilesToRemove = state.removeUploadedFile.map(file => file.nameForHasura);
          await dispatch('deleteUploadedAttachments', { files: namesOfFilesToRemove, materialCreationId: variables.id });
        }
      } catch (error) {
        notify.error({
          title: i18n.t('cataloger.pages.createNewMaterial.tittleCreationError'),
          message: i18n.t('cataloger.pages.createNewMaterial.editionError'),
        });
        window.console.error("Error on update material request", error);
        throw new Error("Update material request failed");
      }
    },
    async cancelMaterialRequest({ dispatch, state }, variablesMapped) {
      try {
        // Update material request
        const variablesForUpdate = { ...variablesMapped };
        const workflowStepId = state.arrayWorkFlowSteps[0].id; // workflow_step -> Cancel
        variablesForUpdate.workflowStepId = workflowStepId;
        variablesForUpdate.lastAction = state.workflowActions[3].id; // Canceled
        await dispatch('updateMaterialRequest', variablesForUpdate);
        // Create new log for material request
        let comment = null;
        if (state.workflowStepLogMessage && state.workflowStepLogMessage.replace(/\s+/g, '').length > 0) {
          comment = state.workflowStepLogMessage;
        }
        const lastLogOfWorkFlowStep = state.logsMaterialRequest[state.logsMaterialRequest.length - 1];
        const variables = {
          actionId: state.workflowActions[3].id, // workflow_action -> Cancelado
          actualStep: workflowStepId,
          beforeStep: variablesMapped.workflowStepId,
          comment,
          materialCreationId: variablesMapped.id,
          workflowId: variablesMapped.workflowId,
          endAction: new Date().toISOString(),
          actionDate: lastLogOfWorkFlowStep.endAction,
        };
        dispatch("workflowStepLogCreate", variables);
        notify.info({
          title: i18n.t("cataloger.pages.createNewMaterial.tittleCreationSuccess"),
          message: i18n.t("cataloger.pages.createNewMaterial.cancelationSuccess"),
        });
        // Send email notification
        const variablesForEmail = {
          materialCreationId: variablesMapped.id,
          workflowStepId: variablesForUpdate.workflowStepId,
          actionId: state.workflowActions[3].id, // workflow_action -> Cancelado
          organizationDivisionId: variablesMapped.organizationDivisionId,
        };
        dispatch("sendEmailNotification", variablesForEmail);
      } catch (error) {
        notify.error({
          title: i18n.t("cataloger.pages.createNewMaterial.errorTittle"),
          message: i18n.t("cataloger.pages.createNewMaterial.cancelationError"),
        });
        window.console.error("Error on cancel material request", error);
      }
    },
    async uploadAttachments({ state }, { materialId, files }) {
      try {
        const url = `${state.fileManagerURL}/upload-files`;
        const bodyFormData = new FormData();
        if (!materialId || !files) {
          throw new Error(`Material id or files are missing. Material id is: ${materialId}, files are: ${files}`);
        }
        bodyFormData.append('materialCreationId', materialId);
        files.map((file) => {
          if (file.file) {
            bodyFormData.append('file', file.file);
          }
          return file;
        });
        await axios({
          method: "post",
          url,
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
        }).then((response) => {
          response.data.map((file) => {
            if (file.error) {
              notify.error({
                title: i18n.t("cataloger.pages.createNewMaterial.errorTittle"),
                message: file.msg,
              });
            }
            return file;
          });
        });
      } catch (error) {
        notify.error({
          title: i18n.t("cataloger.pages.createNewMaterial.errorTittle"),
          message: i18n.t("cataloger.pages.createNewMaterial.uploadError"),
        });
      }
    },
    async deleteUploadedAttachments({ state }, { files, materialCreationId }) {
      try {
        if (!files || !materialCreationId) {
          throw new Error(`Material name or id is missing or not set correctly.`);
        }
        const data = JSON.stringify({
          materialCreationId,
          files,
        });
        const configAxios = {
          method: 'delete',
          url: `${state.fileManagerURL}/delete`,
          headers: {
            'Content-Type': 'application/json',
          },
          data,
        };
      await axios(configAxios)
        .then((response) => {
          response.data.map((file) => {
            if (file.error) {
              notify.error({
                title: i18n.t("cataloger.pages.createNewMaterial.errorTittle"),
                message: file.msg,
              });
            }
            return file;
          });
        }).catch((error) => {
          throw new Error("File could not be deleted ", error);
        });
      } catch (error) {
        notify.error({
          title: i18n.t("cataloger.pages.createNewMaterial.errorTittle"),
          message: i18n.t("cataloger.pages.createNewMaterial.deleteFileError"),
        });
        window.console.error(error);
      }
    },
    async getSearchedMatchedItems({ commit }, { searchID, calledFromProvider = false }) {
      try {
        const searchQuery = {
          query: GET_SIMILAR_MATERIALS,
          variables: { searchID },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          const formatData = result.data.item_match.map(item => ({ item_match: item.match, ...item.item }));
          const objectForSaveSearch = {
            data: formatData,
            searchKeywords: "", // Not needed at this moment
          };
          if (calledFromProvider) {
            commit('cat4mroCataloger/SET_CAT4MRO_PROVIDERS_SEARCH', objectForSaveSearch, { root: true });
            return;
          }
          commit('cat4mroCataloger/SET_SAVE_CAT4MRO_SEARCH', objectForSaveSearch, { root: true });
        }
      } catch (error) {
        window.console.error(error);
      }
    },
    async saveSearchProvidersAndEditMaterialRequest({ dispatch, rootGetters }, variablesMapped) {
      try {
        // Save search
        const userProfile = rootGetters['auth/currentUserProfileInfo'];
        let country = "CL";
        if (userProfile && userProfile.organization) {
          country = userProfile.organization.country;
        }
        const searchData = {
          organization_id: null,
          offset: 0,
          limit: 10,
          keywords: variablesMapped.shortDescription.toUpperCase(),
          category_id: null,
          catalog_type: 1,
          country,
        };
        const result = await dispatch('cat4mroCataloger/newSaveSearch', { filters: searchData }, { root: true });
        if (result && result.data.newSearchStatistics && variablesMapped.id) {
          // Update searchStatisticProvider on material request
          const insertMutation = {
            mutation: SET_SUGGESTED_PROVIDERS,
            variables: { id: variablesMapped.id, searchStatisticProvider: result.data.newSearchStatistics.returning[0].id },
          };
          apolloClient.mutate(insertMutation);
        }
        return result;
      } catch (error) {
        window.console.error(error);
        return error;
      }
    },
    async getWorkflowUser({ commit }, variables) {
      try {
        const searchQuery = {
          query: GET_MDM_WORKFLOW_USER,
          variables,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data && result.data.mdm_workflow_user.length > 0) {
          commit('SET_ORGANIZATION_DIVISIONS', result.data.mdm_workflow_user);
          commit('SET_WORKFLOW_USER', result.data.mdm_workflow_user);
        }
      } catch (error) {
        window.console.error(error);
      }
    },
    async getWorkflowStepAttributeMetaData({ state, commit }, workflowStepId) {
      try {
        const variables = {
          workflowID: state.creationWorkflowID,
          workflowStepId,
        };
        const searchQuery = {
          query: GET_MDM_WORKFLOW_STEP_ATTRIBUTE,
          variables,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_WORKFLOW_STEP_ATTRIBUTE', result.data.attributeMeta);
          return result.data.attibuteMeta;
        }
      } catch (error) {
        window.console.error(error);
      }
      return null;
    },
    async getAnalystsNames() {
      try {
        const searchQuery = {
          query: GET_ANALYSTS_NAMES,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          return result.data.analysts_names;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async getPurchasingOfficers() {
      try {
        const searchQuery = {
          query: GET_PURCHASING_OFFICERS,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          return result.data.purchasing_officers;
        }
      } catch (error) {
        window.console.error(error);
      }
      return [];
    },
    async GET_WORKFLOW_ID({ state, dispatch }, variables) {
      try {
        const searchQuery = {
          query: GET_WORKFLOW_ID,
          variables,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data && result.data.mdm_workflow.length > 0) {
          Vue.set(state, 'creationWorkflowID', result.data.mdm_workflow[0].id);
          dispatch('getWorkFlowSteps', state.creationWorkflowID);
          return result.data.mdm_workflow[0].id;
        }
      } catch (error) {
        window.console.error(error);
      }
      return null;
    },
    async GET_WORKFLOW_ACTIONS({ state }) {
      try {
        const searchQuery = {
          query: GET_WORKFLOW_ACTIONS,
          variables: {
            workflowID: state.creationWorkflowID,
          },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data && result.data.mdm_workflow_action.length > 0) {
          Vue.set(state, 'workflowActions', result.data.mdm_workflow_action);
          return result.data.mdm_workflow_action;
        }
      } catch (error) {
        window.console.error(error);
      }
      return null;
    },
  },
  mutations: {
    SET_MATERIALS_REQUEST(state, data) {
      state.materialsRequests = {};
      state.materialsRequests = data;
    },
    SET_WORKFLOW_STEPS_ARRAY(state, data) {
      state.arrayWorkFlowSteps = data;
    },
    SET_ITEM_NAME_CODE_DROPDOWN(state, data) {
      state.itemNameCodeDropdown = data;
    },
    SET_PRODUCT_SERVICE_CATEGORY_DROPDOWN(state, data) {
      state.productServiceCategoryDropdown = state.productServiceCategoryDropdown.concat(data);
    },
    SET_CATEGORY(state, data) {
      state.inventoryCategories = data;
    },
    SET_STOCK_TYPE(state, data) {
      state.stockType = data;
    },
    SET_AVAILABILITY(state, data) {
      state.availabilityDropdown = data;
    },
    SET_CRITICALLITY_SOS(state, data) {
      state.criticallitySosDropdown = data;
    },
    SET_ANUAL_CONSUMPTION(state, data) {
      state.anualConsumptionDropdown = data;
    },
    SET_EXPENSE_ITEM(state, data) {
      state.expenseItemDropdown = data;
    },
    SET_HAZARD_INDEX(state, data) {
      state.hazardIndexDropdown = data;
    },
    SET_RESPONSIBLE_AREA(state, data) {
      state.responsibleAreaDropdown = data;
    },
    SET_WAREHOUSE(state, data) {
      state.warehouseDropdown = data;
    },
    SET_STOCK_QUALIFIERS(state, data) {
      state.stockQualifiersDropdown = data.map(item => ({ key: item.id, label: item.description }));
    },
    SET_OPERATIONAL_AREA(state, data) {
      state.operationalAreaDropdown = data;
    },
    SET_GROUP_REFERENCE(state, data) {
      state.groupReference = data;
    },
    SET_EQUIPMENT_REFERENCE(state, data) {
      state.equipmentReference = data;
    },
    SET_COMPONENT_CODE(state, data) {
      state.componentCodeDropdown = data;
    },
    SET_UOM(state, data) {
      state.uomDropdown = data;
    },
    CLEAR_MATERIAL_REQUEST_VARIABLES(state) {
      state.materialRequestVariables = {};
      state.filesForMatReq = [];
    },
    MAP_DATA_FROM_FRONT_TO_BACK(
      state,
      { descGeneral, inventarioTab, equipmentAPLTab, descriptionTab, analyst },
    ) {
      let nameItem = null;
      let manPre1 = null;
      let manPre2 = null;
      let man2Id = null;
      let man2Acronym = null;
      let man2PartNumber = null;
      let dateSOSFormat = null;
      if (descGeneral.name) {
        nameItem = descGeneral.name.trim().split(" ")[0];
      }
      if (descGeneral.manufacturer && descGeneral.manufacturer.name) {
        manPre1 = descGeneral.manufacturer.acronym.substring(0, 1);
      }
      if (descGeneral.manufacturer2) {
        if (descGeneral.isManufacturer2enabled) {
          manPre2 = descGeneral.manufacturer2.acronym.substring(0, 1);
          man2Id = descGeneral.manufacturer2.name;
          man2Acronym = descGeneral.manufacturer2.acronym;
          man2PartNumber = descGeneral.manufacturer2.partNumber;
        }
      }
      if (inventarioTab.sosDate) {
        dateSOSFormat = new Date(inventarioTab.sosDate);
        dateSOSFormat = dateSOSFormat.toISOString().split('T')[0];
      }
      state.filesForMatReq = descGeneral.attached_file;
      state.materialRequestVariables = {
        erpCode: null,
        isIntegrated: 0,
        workflowId: state.creationWorkflowID,
        workflowStepId: state.arrayWorkFlowSteps[1].id,
        requestTypeId: 1,
        lastAction: state.workflowActions[0].id,
        name: nameItem,
        itemNameCodeId: descGeneral.item_code_name,
        segmento: descGeneral.segment,
        familia: descGeneral.family,
        clase: descGeneral.class,
        classGroupId: descGeneral.productServiceCategory,
        estimatedPrice: descGeneral.price,
        unitId: descGeneral.uom,
        urgency: Number(descGeneral.isUrgent), // From boolean (true or false) to tinyInt (1 or 0)
        reemplazaCodigoEllipse: descGeneral.ellipseCode,
        manufacturerPre1: manPre1,
        manufacturerId1: descGeneral.manufacturer.name,
        manufacturerAbbreviation1: descGeneral.manufacturer.acronym,
        partNumber1: descGeneral.manufacturer.partNumber,
        manufacturerPre2: manPre2,
        manufacturerId2: man2Id,
        manufacturerAbbreviation2: man2Acronym,
        partNumber2: man2PartNumber,
        enabledManufacturer2: descGeneral.isManufacturer2enabled,
        organizationDivisionId: descGeneral.organizationDivisionId,
        categoryId: inventarioTab.category_selected,
        stockTypeId: inventarioTab.typeStockSelected,
        userResponsibleSOS: inventarioTab.sosUser,
        dateSOS: dateSOSFormat,
        stockMinSOS: inventarioTab.minimumStock,
        stockMaxSOS: inventarioTab.maximumStock,
        criticalitySOSId: inventarioTab.criticalitySOS,
        availibilityId: inventarioTab.availabilitySelected,
        annualConsumptionId: inventarioTab.annualConsumptionSelected,
        expenseItemId: inventarioTab.expenseItemSelected,
        hazardIndexId: inventarioTab.dangerIndexSelected,
        responsibleAreaId: inventarioTab.responsibleAreaSelected,
        warehouseId: inventarioTab.warehouseSelected,
        criticality: inventarioTab.criticality,
        qualifierStockId2: inventarioTab.stockQualifierSelected.join(';'),
        operationalAreaId1:
          equipmentAPLTab.equipmentAPL1.operationalAreaSelected,
        equipmentTypeId1: equipmentAPLTab.equipmentAPL1.equipmentGroupSelected,
        equipmentReferenceId1:
          equipmentAPLTab.equipmentAPL1.equipmentReferenceSelected,
        referenceGroup1: equipmentAPLTab.equipmentAPL1.groupReferenceSelected,
        componentCodeId1: equipmentAPLTab.equipmentAPL1.componentCodeSelected,
        installedQuantity1: equipmentAPLTab.equipmentAPL1.installedQuantity,
        operationalAreaId2:
          equipmentAPLTab.equipmentAPL2.operationalAreaSelected,
        equipmentTypeId2: equipmentAPLTab.equipmentAPL2.equipmentGroupSelected,
        equipmentReferenceId2:
          equipmentAPLTab.equipmentAPL2.equipmentReferenceSelected,
        referenceGroup2: equipmentAPLTab.equipmentAPL2.groupReferenceSelected,
        componentCodeId2: equipmentAPLTab.equipmentAPL2.componentCodeSelected,
        installedQuantity2: equipmentAPLTab.equipmentAPL2.installedQuantity,
        operationalAreaId3:
          equipmentAPLTab.equipmentAPL3.operationalAreaSelected,
        equipmentTypeId3: equipmentAPLTab.equipmentAPL3.equipmentGroupSelected,
        equipmentReferenceId3:
          equipmentAPLTab.equipmentAPL3.equipmentReferenceSelected,
        referenceGroup3: equipmentAPLTab.equipmentAPL3.groupReferenceSelected,
        componentCodeId3: equipmentAPLTab.equipmentAPL3.componentCodeSelected,
        installedQuantity3: equipmentAPLTab.equipmentAPL3.installedQuantity,
        operationalAreaId4:
          equipmentAPLTab.equipmentAPL4.operationalAreaSelected,
        equipmentTypeId4: equipmentAPLTab.equipmentAPL4.equipmentGroupSelected,
        equipmentReferenceId4:
          equipmentAPLTab.equipmentAPL4.equipmentReferenceSelected,
        referenceGroup4: equipmentAPLTab.equipmentAPL4.groupReferenceSelected,
        componentCodeId4: equipmentAPLTab.equipmentAPL4.componentCodeSelected,
        installedQuantity4: equipmentAPLTab.equipmentAPL4.installedQuantity,
        colloquial1: descriptionTab.colloquial1,
        colloquial2: descriptionTab.colloquial2,
        colloquial3: descriptionTab.colloquial3,
        colloquial4: descriptionTab.colloquial4,
        colloquial5: descriptionTab.colloquial5,
        shortDescription: descriptionTab.shortText,
        extendDescription: descriptionTab.extendedDescription,
        stockMin: analyst.minimumStock,
        analystNameId: analyst.analystNameId,
        isActive: null,
        preEquipmentReference1: null,
        preEquipmentReference2: null,
        preEquipmentReference3: null,
        preEquipmentReference4: null,
        preference1: analyst.manufacturer1.preference,
        preference2: analyst.manufacturer2.preference,
        purchasing: analyst.purchasingOfficerId,
        reorderPoint: analyst.reorderPoint,
        reorderQuantity: analyst.reorderQuantity,
        partNumberRf1: analyst.manufacturer1.partNumber,
        partNumberRf2: analyst.manufacturer2.partNumber,
      };
      const stock2 = inventarioTab.stockQualifierSelected.map((idQualifier) => {
        const getQualifier = state.stockQualifiersDropdown.find(qualifier => qualifier.key === idQualifier);
        return getQualifier.label.split(' - ')[0];
      });
      state.materialRequestVariables.qualifierStockId = stock2.join(';');
      if (descGeneral.id) {
        state.materialRequestVariables.id = descGeneral.id;
        state.materialRequestVariables.updatedAt = new Date().toISOString();
        state.materialRequestVariables.workflowStepId = descGeneral.workflowStepId;
      } else {
        delete state.materialRequestVariables.partNumberRf1;
        delete state.materialRequestVariables.partNumberRf2;
      }
    },
    SET_MATERIAL_REQUEST_ID(state, id) {
      state.editMaterialRequestID = id;
    },
    SET_DELETE_UPLOADED_FILES(state, { file, clearData = false }) {
      if (clearData) {
        state.removeUploadedFile.splice(0);
      } else {
        Vue.set(state.removeUploadedFile, state.removeUploadedFile.length, file);
      }
    },
    SET_WORKFLOW_STEP(state, workflowStep) {
      state.workflowStep = workflowStep;
    },
    SET_WORKFLOW_STEP_LOG_MESSAGE(state, workflowStepLogMessage) {
      state.workflowStepLogMessage = workflowStepLogMessage;
    },
    SET_LOGS_MATERIAL_REQUEST(state, logsMaterialRequest) {
      state.logsMaterialRequest = logsMaterialRequest;
    },
    SET_ARRAY_KEYWORDS_SEARCH(state, arrayKeyWordsSearch) {
      state.arrayKeyWordsSearch = arrayKeyWordsSearch;
    },
    SET_TMP_SHORT_DESCRIPTION(state, tmpDescription) {
      state.tmpDescription = tmpDescription;
    },
    SET_EDIT_MATERIAL_WORKFLOW_STEP_ID(state, editMaterialWorkflowStepId) {
      state.editMaterialWorkflowStepId = editMaterialWorkflowStepId;
    },
    SET_WORKFLOW_STEP_ATTRIBUTE(state, workflowStepAttribute) {
      const newArr = {};
      workflowStepAttribute.map((item) => {
        newArr[item.workflow_attribute.nombreBaseDato] = item;
        return item; // eslint array-callback-return
      });
      state.workflowStepAttribute = newArr;
    },
    SET_ORGANIZATION_DIVISIONS(state, workFlowUserData) {
      if (!workFlowUserData) {
        return;
      }
      const organizationDivisions = workFlowUserData.map(item => item.organization_division); // Gets the organization divisions
      const ids = [...new Set(
          organizationDivisions.map((org) => {
            if (org) {
              return org.id;
            }
            return org;
          } // eslint-disable-line
          ))]; // Gets the organization divisions ids
      const objOrg = {};
      organizationDivisions.map((org) => {
        if (org && org.id) {
          objOrg[org.id] = org;
        }
        return org;
      });
      Vue.set(state.organizationDivisions, 'array', organizationDivisions); // For dropdown list
      Vue.set(state.organizationDivisions, 'ids', ids); // For query "GET_MATERIALS_REQUESTS"
      Vue.set(state.organizationDivisions, 'object', objOrg); // To show name of organization division in the table of material request
    },
    SET_WORKFLOW_USER(state, workFlowUserData) {
      state.workFlowsUser = workFlowUserData;
    },
    SET_ORGANIZATION_ID_CREATE_MATERIAL(state, organizationIdCreateMaterial) {
      state.organizationIdCreateMaterial = organizationIdCreateMaterial;
    },
  },
};

export default materials;



// WEBPACK FOOTER //
// ./src/store/modules/cataloger/materials.js